import { API_BASE_URL, API_URL } from '@/config/api.config';

const getBaseUrl = () => {
  return API_URL;
};

export const BASE_URL = getBaseUrl();

export const ApiEndpoints = {
  // Auth endpoints
  auth: {
    validateInvitation: `${BASE_URL}/users/auth0/validate-invitation/`,
    setupPassword: `${BASE_URL}/users/auth0/setup-password/`,
  },

  // Asset endpoints
  assets: {
    base: `${BASE_URL}/assets`,
    list: `${BASE_URL}/assets/`,
    // Same listing shape as `list`, but excludes assets already mid-transfer,
    // mid-disposal, or on an open movement-tracked activity - for the asset
    // transfer creation picker specifically.
    transferSelection: `${BASE_URL}/assets/transfers/transferable-assets/`,
    // Same exclusion rules as transferSelection, for the asset disposal
    // creation picker specifically.
    disposalSelection: `${BASE_URL}/assets/disposals/disposable-assets/`,
    detail: (id: string) => `${BASE_URL}/assets/${id}/`,
    byCategory: (category: string) =>
      `${BASE_URL}/assets/category/${category}/`,
    byLocation: (location: string) =>
      `${BASE_URL}/assets/location/${location}/`,
    byStatus: (status: string) => `${BASE_URL}/assets/status/${status}/`,
    assign: (assetId: string) => `${BASE_URL}/assets/${assetId}/assign/`,
    unassign: (assetId: string) => `${BASE_URL}/assets/${assetId}/unassign/`,
    transferHistory: (assetId: string) => `${BASE_URL}/assets/${assetId}/transfer-history/`,
    auditRequests: (assetId: string) => `${BASE_URL}/assets/${assetId}/audit-requests/`,
    scheduledActivities: (assetId: string) => `${BASE_URL}/assets/${assetId}/scheduled-activities/`,
  },

  // Asset Master endpoints
  assetMasters: {
    base: `${BASE_URL}/assets/master`,
    list: `${BASE_URL}/assets/master/`,
    detail: (id: string) => `${BASE_URL}/assets/master/${id}/`,
    referenceData: `${BASE_URL}/assets/master/reference-data/`,
  },

  // Manufacturer endpoints
  manufacturers: {
    base: `${BASE_URL}/assets/manufacturers`,
    list: `${BASE_URL}/assets/manufacturers/`,
    detail: (id: string) => `${BASE_URL}/assets/manufacturers/${id}/`,
    history: (id: string) => `${BASE_URL}/assets/manufacturers/history/?id=${id}`,
  },

  // Model endpoints
  models: {
    base: `${BASE_URL}/master/models`,
    list: `${BASE_URL}/master/models/`,
    detail: (id: string) => `${BASE_URL}/master/models/${id}/`,
    history: (id: string) => `${BASE_URL}/master/models/history/?id=${id}`,
  },


  // Company endpoints
  companies: {
    base: `${BASE_URL}/company/companies`,
    list: `${BASE_URL}/company/companies/`,
    detail: (id: string) => `${BASE_URL}/company/companies/${id}/`,
    hierarchy: `${BASE_URL}/company/companies/hierarchy/`,
    history: (id: string) => `${BASE_URL}/company/companies/${id}/history/`,
  },

  companylocation: {
    base: `${BASE_URL}/company/company/locations`,
    list: `${BASE_URL}/company/company/locations/`,
    detail: (id: string) => `${BASE_URL}/company/company/locations/${id}/`,
    hierarchy: `${BASE_URL}/company/company/locations/hierarchy/`,
  },
  // Department endpoints

  departments: {
    base: `${BASE_URL}/company/departments`,
    list: `${BASE_URL}/company/departments/`,
    detail: (id: string) => `${BASE_URL}/company/departments/${id}/`,
    hierarchy: `${BASE_URL}/company/departments/hierarchy/`,
    history: (id: string) => `${BASE_URL}/company/departments/history/?id=${id}`,
  },

  // Asset Category endpoints
  assetCategories: {
    base: `${BASE_URL}/assets/asset-categories`,
    list: `${BASE_URL}/assets/asset-categories/`,
    detail: (id: string) => `${BASE_URL}/assets/asset-categories/${id}/`,
    hierarchy: `${BASE_URL}/assets/asset-categories/hierarchy/`,
    history: (id: string) => `${BASE_URL}/assets/asset-categories/history/?id=${id}`,
  },

  // Asset Status endpoints
  assetStatuses: {
    base: `${BASE_URL}/assets/addon/asset-statuses`,
    list: `${BASE_URL}/assets/addon/asset-statuses/`,
    detail: (id: string) => `${BASE_URL}/assets/addon/asset-statuses/${id}/`,
    history: (id: string) => `${BASE_URL}/master/asset-statuses/history/?id=${id}`,
  },

  // Asset Conditions endpoints
  assetConditions: {
    base: `${BASE_URL}/master/asset-conditions`,
    list: `${BASE_URL}/master/asset-conditions/`,
    detail: (id: string) => `${BASE_URL}/master/asset-conditions/${id}/`,
    history: (id: string) => `${BASE_URL}/master/asset-conditions/history/?id=${id}`,
  },

  // Country endpoints
  countries: {
    base: `${BASE_URL}/master/countries`,
    list: `${BASE_URL}/master/countries/`,
    detail: (id: string) => `${BASE_URL}/master/countries/${id}/`,
    history: (id: string) => `${BASE_URL}/master/countries/${id}/history/`,
  },

  // State endpoints
  states: {
    base: `${BASE_URL}/master/states`,
    list: `${BASE_URL}/master/states/`,
    detail: (id: string) => `${BASE_URL}/master/states/${id}/`,
    history: (id: string) => `${BASE_URL}/master/states/${id}/history/`,
  },

  // Site endpoints
  siteEndpoints: {
    sites: {
      base: `${BASE_URL}/master/sites`,
      list: `${BASE_URL}/master/sites/`,
      detail: (id: string) => `${BASE_URL}/master/sites/${id}/`,
      history: (id: string) => `${BASE_URL}/master/sites/history/?id=${id}`,
    },
    // other modules...
  },

  // Location endpoints
  LocationrtkQuery: {
    locations: {
      base: `${BASE_URL}/master/locations`,
      list: `${BASE_URL}/master/locations/`,
      dropdown: `${BASE_URL}/master/locations/dropdown/`,
      types: `${BASE_URL}/master/locations/types/`,
      parentTypes: `${BASE_URL}/master/locations/parent/types/`,
      all: `${BASE_URL}/master/locations/all/`,
      detail: (id: string) => `${BASE_URL}/master/locations/${id}/`,
      hierarchy: `${BASE_URL}/master/locations/hierarchy/`,
      assets: (locationId: string) =>
        `${BASE_URL}/master/locations/${locationId}/assets/`,
      byHierarchy: `${BASE_URL}/master/locations/by-hierarchy/`,
      history: (id: string) => `${BASE_URL}/master/locations/history/?id=${id}`,
    },
  },

  // Supplier endpoints
  suppliers: {
    base: `${BASE_URL}/suppliers/suppliers`,
    list: `${BASE_URL}/suppliers/suppliers/`,
    detail: (id: string) => `${BASE_URL}/suppliers/suppliers/${id}/`,
    history: (id: string) => `${BASE_URL}/suppliers/suppliers/history/?id=${id}`,
  },

  // RTK Query endpoints (for Redux Toolkit Query API slices)
  rtkQuery: {
    companies: {
      getCompanies: 'getCompanies',
      getCompanyById: (id: string) => `getCompany/${id}`,
      createCompany: 'createCompany',
      updateCompany: (id: string) => `updateCompany/${id}`,
      getCompanyHierarchy: 'getCompanyHierarchy',
      getCompanyHistory: (id: string) => `getCompanyHistory/${id}`,
    },
    countries: {
      getCountries: 'getCountries',
      getCountryById: (id: string) => `getCountry/${id}`,
      createCountry: 'createCountry',
      updateCountry: (id: string) => `updateCountry/${id}`,
      getCountryHistory: (id: string) => `getCountryHistory/${id}`,
    },
    states: {
      getStates: 'getStates',
      getStateById: (id: string) => `getState/${id}`,
      createState: 'createState',
      updateState: (id: string) => `updateState/${id}`,
      getStateHistory: (id: string) => `getStateHistory/${id}`,
    },
    sites: {
      getSites: 'getSites',
      getSiteById: (id: string) => `getSite/${id}`,
      createSite: 'createSite',
      updateSite: (id: string) => `updateSite/${id}`,
    },
    locations: {
      getLocations: 'getLocations',
      getAllLocations: 'getAllLocations',
      getLocationById: (id: string) => `getLocation/${id}`,
      createLocation: 'createLocation',
      updateLocation: (id: string) => `updateLocation/${id}`,
      getLocationHierarchy: 'getLocationHierarchy',
      getLocationAssets: (id: string) => `getLocationAssets/${id}`,
      getLocationsByHierarchy: 'getLocationsByHierarchy',
    },
  },

  // Workflow endpoints
  workflows: {
    templates: {
      base: `${BASE_URL}/workflows/workflow-templates`,
      list: `${BASE_URL}/workflows/workflow-templates/`,
      detail: (id: string) => `${BASE_URL}/workflows/workflow-templates/${id}/`,
    },
    transactions: {
      base: `${BASE_URL}/workflows/workflow-transactions`,
      list: (() => {
        const url = `${BASE_URL}/workflows/workflow-transactions/`;
        return url;
      })(),
      detail: (id: string) => {
        const url = `${BASE_URL}/workflows/workflow-transactions/${id}/`;
        return url;
      },
      approvalLevels: (id: string) => `${BASE_URL}/workflows/workflow-transactions/${id}/approval-levels/`,
      myTransactions: `${BASE_URL}/workflows/workflow-transactions/?my_transactions=true`,
    },
    approvalTasks: {
      base: `${BASE_URL}/workflows/approval-tasks`,
      list: `${BASE_URL}/workflows/approval-tasks/`,
      detail: (id: string) => `${BASE_URL}/workflows/approval-tasks/${id}/`,
      myTasks: `${BASE_URL}/workflows/approval-tasks/?my_tasks=true`,
    }
  },
  roles: {
    base: `${BASE_URL}/roles`,
    list: `${BASE_URL}/roles/`,
    detail: (id: string) => `${BASE_URL}/roles/${id}/`,
  },
  // Schedule management endpoints
  schedule: {
    activityTypes: {
      list: () => `${BASE_URL}/master/schedule/activity-types/`,
      detail: (id: string) => `${BASE_URL}/master/schedule/activity-types/${id}/`,
    },
    userGroups: {
      list: () => `${BASE_URL}/master/schedule/user-groups/`,
      detail: (id: string) => `${BASE_URL}/master/schedule/user-groups/${id}/`,
    },
    costTemplates: {
      list: () => `${BASE_URL}/master/schedule/cost-templates/`,
      detail: (id: string) => `${BASE_URL}/master/schedule/cost-templates/${id}/`,
    },
    checklistTemplates: {
      list: () => `${BASE_URL}/master/schedule/checklist-templates/`,
      detail: (id: string) => `${BASE_URL}/master/schedule/checklist-templates/${id}/`,
      canDelete: (id: string) => `${BASE_URL}/master/schedule/checklist-templates/${id}/`,
    },
    activities: {
      list: `${BASE_URL}/schedule/activities/`,
      detail: (id: string) => `${BASE_URL}/schedule/activities/${id}`,
      updateStatus: (id: string) => `${BASE_URL}/schedule/activities/${id}/update_status/`,
      assignUser: (id: string) => `${BASE_URL}/schedule/activities/${id}/assign_user/`,
      details: (id: string) => `${BASE_URL}/schedule/activities/${id}/details/`,
      access: (id: string) => `${BASE_URL}/schedule/activities/${id}/access/`,
      // Fix the generate activities endpoint to match the backend URL
      generate: `${BASE_URL}/schedules/generate_activities/`,
      createOneOff: `${BASE_URL}/schedule/activities/create_one_off/`,
      pending: `${BASE_URL}/schedule/activities/pending/`,
      start: (id: string) => `${BASE_URL}/schedule/activities/${id}/start/`,
      pause: (id: string) => `${BASE_URL}/schedule/activities/${id}/pause/`,
      resume: (id: string) => `${BASE_URL}/schedule/activities/${id}/resume/`,
      complete: (id: string) => `${BASE_URL}/schedule/activities/${id}/complete/`,
      updateChecklist: (id: string) => `${BASE_URL}/schedule/activities/${id}/update_checklist/`,
    },
  },
  
  // Notification endpoints
  notifications: {
    list: `${BASE_URL}/notifications/api/`,
    unread: `${BASE_URL}/notifications/api/unread/`,
    unreadCount: `${BASE_URL}/notifications/api/unread/count/`,
    markAsRead: (id: string) => `${BASE_URL}/notifications/api/${id}/read/`,
    markAllAsRead: `${BASE_URL}/notifications/api/read-all/`,
    preferences: {
      list: `${BASE_URL}/notifications/api/preferences/`,
      getByType: `${BASE_URL}/notifications/api/preferences/?type=`,
      setPreference: `${BASE_URL}/notifications/api/preferences/`,
      test: `${BASE_URL}/notifications/api/test/`,
    },
  },
  dashboard: {
    config: `${BASE_URL}/reporting/dashboard/config/`,
    charts: (chart: string) => `${BASE_URL}/reporting/dashboard/charts/${chart}/`,
    chartType: (chart: string, chartType: string) => `${BASE_URL}/reporting/dashboard/charts/${chart}/${chartType}/`,
    export: `${BASE_URL}/reporting/dashboard/export/`,
    preferences: `${BASE_URL}/reporting/dashboard/preferences/`,
    summary: `${BASE_URL}/reporting/dashboard/metrics/summary/`,
  },
  reports: {
    categories: `${BASE_URL}/reporting/api/reports/categories/`,
    assetTransferTypes: `${BASE_URL}/reporting/api/reports/asset-transfers/types/`,
    reportData: (reportType: string) => `${BASE_URL}/reporting/api/reports/generic/${reportType}/data/`,
    assetTransferData: (reportType: string) => `${BASE_URL}/reporting/api/reports/asset-transfers/data/${reportType}/`,
    exportReport: (reportType: string) => `${BASE_URL}/reporting/api/reports/generic/${reportType}/export/`,
    assetDisposalTypes: `${BASE_URL}/reporting/api/reports/asset-disposals/types/`,
    assetDisposalData: (reportType: string) => `${BASE_URL}/reporting/api/reports/asset-disposals/data/${reportType}/`,
    assetLiveTypes: `${BASE_URL}/reporting/api/reports/asset-live/types/`,
    assetLiveData: (reportType: string) => `${BASE_URL}/reporting/api/reports/asset-live/data/${reportType}/`,
    assetTaggingTypes: `${BASE_URL}/reporting/api/reports/asset-tagging/types/`,
    assetTaggingData: (reportType: string) => `${BASE_URL}/reporting/api/reports/asset-tagging/data/${reportType}/`,
    assetValuationTypes: `${BASE_URL}/reporting/api/reports/asset-valuation/types/`,
    assetValuationData: (reportType: string) => `${BASE_URL}/reporting/api/reports/asset-valuation/data/${reportType}/`,
    assetUtilizationTypes: `${BASE_URL}/reporting/api/reports/asset-utilization/types/`,
    assetUtilizationData: (reportType: string) => `${BASE_URL}/reporting/api/reports/asset-utilization/data/${reportType}/`,
    auditData: (reportType: string) => `${BASE_URL}/reporting/api/reports/audits/data/${reportType}/`,
    activityCostData: `${BASE_URL}/reporting/api/reports/activity-costs/data/activity_cost_report/`,
    activitySLAData: `${BASE_URL}/reporting/api/reports/activity-sla/data/activity_sla_report/`,
  },
  // RFID Reader Master endpoints
  rfid: {
    // Reader Authentication and Security Endpoints
    authenticate: `${BASE_URL}/rfid/readers/authenticate/`,
    generateKey: (readerId: string) => `${BASE_URL}/rfid/readers/${readerId}/generate-key/`,
    revokeKey: (readerId: string) => `${BASE_URL}/rfid/readers/${readerId}/revoke-key/`,
    authAttempts: `${BASE_URL}/rfid/reader-auth-attempts/`,
    readerAuthAttempts: (readerId: string) => `${BASE_URL}/rfid/readers/${readerId}/auth-attempts/`,
    
    // Reader Type Endpoints
    readerTypes: `${BASE_URL}/rfid/reader-types/`,
    readerTypeDetail: (typeId: string) => `${BASE_URL}/rfid/reader-types/${typeId}/`,
    activeReaderTypes: `${BASE_URL}/rfid/reader-types/active/`,
    
    // Reader Management Endpoints
    readers: `${BASE_URL}/rfid/readers/`,
    readerDetail: (readerId: string) => `${BASE_URL}/rfid/readers/${readerId}/`,
    readerActivityLogs: (readerId: string) => `${BASE_URL}/rfid/readers/${readerId}/activity-logs/`,
    readerMqttCredentials: (readerId: string) => `${BASE_URL}/rfid/readers/${readerId}/mqtt-credentials/`,
    bulkImport: `${BASE_URL}/rfid/readers/bulk-import/`,
    
    // Reader Location Assignment Endpoints
    locationHierarchy: `${BASE_URL}/rfid/locations/hierarchy/`,
    locationReaders: (locationId: string) => `${BASE_URL}/rfid/locations/${locationId}/readers/`,
    
    // Reader-based Reporting Endpoints
    assetScans: `${BASE_URL}/rfid/asset-scans/`,
    readerScanStatistics: (readerId: string) => `${BASE_URL}/rfid/readers/${readerId}/scan-statistics/`,
    assetScanExport: `${BASE_URL}/rfid/asset-scans/export/`,
    
    // Vehicle Management Endpoints
    vehicles: `${BASE_URL}/rfid/vehicles/`,
    vehicleDropdown: `${BASE_URL}/rfid/vehicles/dropdown/`,
    vehicleDetail: (vehicleId: string) => `${BASE_URL}/rfid/vehicles/${vehicleId}/`,
    vehicleScanAll: `${BASE_URL}/rfid/vehicles/scans/`,
    
    // Vehicle RFID Association Endpoints
    vehicleScanHandheld: `${BASE_URL}/rfid/vehicles/scan/`,
    readerVehicleScan: (readerId: string) => `${BASE_URL}/rfid/readers/${readerId}/scan/`,
    
    // Vehicle Transfer Integration Endpoints
    vehicleAvailability: (vehicleId: string) => `${BASE_URL}/assets/transfers/vehicles/${vehicleId}/availability/`,
    
    // Vehicle Transfer Matching Configuration Endpoints
    transferMatchingConfigs: `${BASE_URL}/rfid/vehicle-transfer-configs/`,
    transferMatchingConfigDetail: (configId: string) => `${BASE_URL}/rfid/vehicle-transfer-configs/${configId}/`,
    activeTransferMatchingConfigs: `${BASE_URL}/rfid/vehicle-transfer-configs/active/`,
    toggleTransferMatchingConfig: (configId: string) => `${BASE_URL}/rfid/vehicle-transfer-configs/${configId}/toggle-active/`,
  },

  // Floor Plan endpoints
  // Location hierachy end point is created seperately for floorplan as generic hierarchy response is not suitable for showing hierarchys
  floorPlans: {
    base: `${BASE_URL}/floor-plans`,
    list: `${BASE_URL}/floor-plans/list/`,
    detail: (id: string) => `${BASE_URL}/floor-plans/list/${id}/`,
    upload: `${BASE_URL}/floor-plans/upload/`,
    preview: (id: string) => `${BASE_URL}/floor-plans/list/${id}/preview/`,
    tile: (id: string, z: number, x: number, y: number) =>
      `${BASE_URL}/floor-plans/list/${id}/tiles/${z}/${x}/${y}/`,
    locationFloorPlans: (locationId: string) =>
      `${BASE_URL}/floor-plans/locations/${locationId}/floor-plans/`,
    // locationHierarchy: `${BASE_URL}/floor-plans/locations/hierarchy/`,
  },

  // Custom Forms endpoints
  customForms: {
    base: `${BASE_URL}/custom-forms`,
    sections: `${BASE_URL}/custom-forms/sections/`,
    sectionDetail: (id: string) => `${BASE_URL}/custom-forms/sections/${id}/`,
    sectionReorder: `${BASE_URL}/custom-forms/sections/reorder/`,
    systemFields: `${BASE_URL}/custom-forms/system-fields/`,
    systemFieldDetail: (slug: string) => `${BASE_URL}/custom-forms/system-fields/${slug}/`,
    listMasters: `${BASE_URL}/custom-forms/list-masters/`,
    listMasterDetail: (id: string) => `${BASE_URL}/custom-forms/list-masters/${id}/`,
    fieldTypes: `${BASE_URL}/custom-forms/field-types/`,
    fieldTypeValidationRules: (fieldType: string) => `${BASE_URL}/custom-forms/field-types/${fieldType}/validation-rules/`,
    entityOptions: `${BASE_URL}/custom-forms/entity-options/`,
    menu: `${BASE_URL}/custom-forms/menu/`,
    // Nested endpoints
    sectionFields: (sectionId: string) => `${BASE_URL}/custom-forms/sections/${sectionId}/fields/`,
    sectionFieldDetail: (sectionId: string, fieldId: string) => `${BASE_URL}/custom-forms/sections/${sectionId}/fields/${fieldId}/`,
    listMasterOptions: (listMasterId: string) => `${BASE_URL}/custom-forms/list-masters/${listMasterId}/options/`,
    listMasterOptionDetail: (listMasterId: string, optionId: string) => `${BASE_URL}/custom-forms/list-masters/${listMasterId}/options/${optionId}/`,
    listMasterOptionReorder: (listMasterId: string) => `${BASE_URL}/custom-forms/list-masters/${listMasterId}/options/reorder/`,
  },

  // Generic Celery task-status endpoint (registered at site root, not under /api/v1)
  tasks: {
    status: (taskId: string) => `${API_BASE_URL}/runner/tasks/${taskId}/`,
  },
};
